<template>
  <div>
    <h1 class="mb-8">Statistiques</h1>
    <div v-if="!loading">
      <strong>
        <v-icon class="mr-2 mb-2">mdi-basket</v-icon>Panier moyen :
      </strong>
      {{ panierMoyen }} €
    </div>
    <div v-else>
      <v-skeleton-loader height="40" type="heading" class="mx-auto"></v-skeleton-loader>
      <v-skeleton-loader height="40" type="heading" class="mx-auto"></v-skeleton-loader>
      <v-skeleton-loader height="40" type="heading" class="mx-auto"></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      loading: false,
    }),
    mounted() {
      this.getStats();
    },
    computed: {
      stats() {
        return this.$store.state.statistiques;
      },
      panierMoyen() {
        if (this.stats.nombreDePaiements === 0) return 0;
        return (
          Math.round(this.stats.montantTotal / this.stats.nombreDePaiements) / 100
        );
      },
    },

    methods: {
      async getStats() {
        this.loading = true;
        await this.$store.dispatch("bindStatistiquesRef");
        this.loading = false;
      },
    },
  };
</script>

